import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FaUserCircle, FaSignOutAlt, FaSearch, FaWhatsapp } from "react-icons/fa";
import { buildWhatsAppUrl } from "../../utils/whatsapp";

const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const isAdmin = user?.role === "admin" || user?.role === "superadmin";

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
        }
    };

    return (
        <header className="h-16 border-b border-[#E5E7EB] bg-[#FFFFFF] px-6 flex items-center justify-between z-20 shadow-sm">
            {/* Mobile Brand Link */}
            <div className="flex items-center gap-2 md:hidden mr-4">
                <Link to="/" className="flex items-center gap-2">
                    <img src="/logo.png" alt="LUMIGO" className="h-7 w-auto object-contain" />
                </Link>
            </div>
            {/* Search Bar */}
            <form onSubmit={handleSearch} className="relative hidden sm:block w-72">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search projector models..."
                    className="w-full bg-[#F7F5EF] border border-[#E5E7EB] rounded-full pl-9 pr-4 py-1.5 text-xs text-[#263746] placeholder-[#687482] focus:outline-none focus:border-[#E3B629]"
                />
                <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#687482] text-xs pointer-events-none" />
            </form>

            <div className="flex items-center gap-4 ml-auto">
                {/* Help Desk Link */}
                <a
                    href={buildWhatsAppUrl(`Hello LUMIGO,\n\nI need support regarding portal navigation.\nUser: ${user?.name} (${user?.email})`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#687482] hover:text-[#168B53] text-xs font-semibold flex items-center gap-1.5 transition"
                >
                    <FaWhatsapp className="text-[#168B53]" /> WhatsApp Support
                </a>

                <div className="h-4 w-[1px] bg-[#E5E7EB]"></div>

                {/* User Info */}
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-[#E3B629]/20 text-[#263746] border border-[#E3B629] flex items-center justify-center font-bold text-xs">
                        {user?.name?.[0]?.toUpperCase() || <FaUserCircle />}
                    </div>
                    <div className="hidden lg:block text-left text-xs">
                        <div className="font-bold text-[#263746] leading-tight">{user?.name || "LUMIGO User"}</div>
                        <div className="text-[10px] text-[#E3B629] uppercase tracking-wider font-bold">
                            {isAdmin ? "Administrator" : "Client Account"}
                        </div>
                    </div>
                </div>

                {/* Logout Button */}
                <button
                    onClick={() => {
                        logout();
                        navigate("/login");
                    }}
                    className="p-2 rounded-lg bg-[#F7F5EF] hover:bg-rose-50 text-[#687482] hover:text-rose-600 border border-[#E5E7EB] text-xs flex items-center gap-1.5 transition"
                    title="Sign Out"
                >
                    <FaSignOutAlt />
                    <span className="hidden sm:inline">Sign Out</span>
                </button>
            </div>
        </header>
    );
};

export default Navbar;
